export enum Menu {
  Account = "/sprites.svg#menu-account",
  Project = "/sprites.svg#menu-project",
  Species = "/sprites.svg#menu-species",
  Systems = "/sprites.svg#menu-systems",
  Users = "/sprites.svg#menu-users",
}
